import { render } from "./mobilemenu.vue?vue&type=template&id=9a4e2e70&scoped=true"
import script from "./mobilemenu.vue?vue&type=script&lang=js"
export * from "./mobilemenu.vue?vue&type=script&lang=js"

import "./mobilemenu.vue?vue&type=style&index=0&id=9a4e2e70&scoped=true&lang=css"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-AfyunProd\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a4e2e70"]])

export default __exports__